import HelperclassContainer from "../../../Components/UiKits/HelperClasses";

export default function HelperClasses() {
  return (
    <div className="page-body">
        <HelperclassContainer/>
    </div>
  )
}
